export const INIT_ONBOARDING_NEW_SS = 'onboarding.newView';
export const INIT_ONBOARDING_OLD_SS = 'onboarding.oldView';

export const ONBOARDING_NEW_FINISHED = 'onboarding.newViewFinished';
export const ONBOARDING_OLD_FINISHED = 'onboarding.oldViewFinished';
